export async function submitTeklif(payload) {
  const res = await fetch("/teklif.php", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }

  if (!res.ok || !data.ok) {
    throw new Error(data.message || "Teklif gönderilemedi. Lütfen telefonla ulaşın.");
  }

  return data;
}
